const EdiExtractSelfServiceDocs = () => (
    <div className="edi-extract-selfservice-docs">
        <p>
            Runs the HRP enrollment, accumulator, benefit plan, and claims EDI
            extracts on demand, instead of waiting for tonight's scheduled run
            — useful right after EDI loads a fix you want to verify immediately.
        </p>
        <p>
            Starts all jobs together and registers their output when done,
            usually within a few minutes. Only one run at a time; can't be
            cancelled once started.
        </p>
    </div>
);

export default EdiExtractSelfServiceDocs;
